// extracted by mini-css-extract-plugin
module.exports = {"item":"DashboardBannerEmpty__item","image":"DashboardBannerEmpty__image"};